var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { computed, ref } from "vue";
import { defineStore } from "pinia";
import { mergeObjectListsById } from "@/utils/utils";
import { loadNotificationsFromServer, loadNotificationsStatus, updateBatchNotificationsOnServer, } from "@/stores/services/notifications.service";
import { useBroadcastsStore } from "./broadcastsStore";
const STATUS_POLLING_DELAY = 5000;
export const useNotificationsStore = defineStore("notificationsStore", () => {
    const broadcastsStore = useBroadcastsStore();
    const totalUnreadCount = ref(0);
    const notifications = ref([]);
    const pollId = ref(null);
    const loadingNotifications = ref(false);
    const lastNotificationUpdate = ref(null);
    const unreadNotifications = computed(() => notifications.value.filter((n) => !n.seen_time));
    function loadNotifications() {
        return __awaiter(this, void 0, void 0, function* () {
            yield loadNotificationsFromServer().then((data) => {
                notifications.value = mergeObjectListsById(data, [], "create_time", "desc");
            });
        });
    }
    function getNotificationStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            stopPollingNotifications();
            try {
                if (!lastNotificationUpdate.value) {
                    loadingNotifications.value = true;
                    yield broadcastsStore.loadBroadcasts();
                    yield loadNotifications();
                }
                else {
                    yield loadNotificationsStatus(lastNotificationUpdate.value).then((data) => {
                        totalUnreadCount.value = data.total_unread_count;
                        notifications.value = mergeObjectListsById(notifications.value, data.notifications, "create_time", "desc");
                        broadcastsStore.updateBroadcasts(data.broadcasts);
                    });
                }
                lastNotificationUpdate.value = new Date();
            }
            catch (e) {
                console.error(e);
            }
            finally {
                loadingNotifications.value = false;
            }
        });
    }
    function startPollingNotifications() {
        return __awaiter(this, void 0, void 0, function* () {
            yield getNotificationStatus();
            pollId.value = setTimeout(() => startPollingNotifications(), STATUS_POLLING_DELAY);
        });
    }
    function stopPollingNotifications() {
        pollId.value = clearTimeout(pollId.value);
    }
    function updateBatchNotification(request) {
        return __awaiter(this, void 0, void 0, function* () {
            yield updateBatchNotificationsOnServer(request);
            if (request.changes.deleted) {
                notifications.value = notifications.value.filter((n) => !request.notification_ids.includes(n.id));
            }
            yield startPollingNotifications();
        });
    }
    function updateNotification(notification, changes) {
        return __awaiter(this, void 0, void 0, function* () {
            return updateBatchNotification({ notification_ids: [notification.id], changes });
        });
    }
    return {
        notifications,
        totalUnreadCount,
        unreadNotifications,
        loadingNotifications,
        updateNotification,
        updateBatchNotification,
        startPollingNotifications,
    };
});
